import { page, userPermission } from '../interface/user';
export const ACTION = {
  LIST: 'list',
  ADD: 'new',
  VIEW: 'view',
  INFO: 'info'
};
export class UrlServices {
  constructor() { }
  public static DASHBOARD_ROUTE = 'dashboard';
  public static USER_PROFILE_ROUTE = 'user-profile';
  public static ACCESS_DENIED_ROUTE = 'access_denied';

  public static AUTH_PAGE = {
    //USER_ROUTE :
    LOGIN_URL: '/' + 'login',
    FORGOT_PASSWORD_URL: '/' + 'forgotPassword',
    RESET_PASSWORD_URL: '/' + 'reset',
    LOGOUT_URL: '/' + 'logout',
    ACTIVATE: '/' + 'activate',
    SIGNUP: '/' + 'signup',
  };
  public static PAGE_URL: page = {

    USER: {
      LIST: {
        URL: '/user' + '/' + ACTION.LIST,
        permission: { moduleName: 'USER', actionName: 'VIEW_ALL' },
      },
      ADD: {
        URL: '/user' + '/' + ACTION.ADD,
        permission: { moduleName: 'USER', actionName: 'ADD' },
      },
      VIEW: {
        URL: '/user' + '/' + ACTION.VIEW,
        permission: { moduleName: 'USER', actionName: 'READ' },
      },
      ROLE: {
        URL: '/user' + '/roles-list',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_ROLE' },
      },
      EDITROLE: {
        URL: '/user' + '/' + 'edit-role',
        // permission: {} as userPermission,
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_ROLE' },
      },
      PERMISSION: {
        URL: '/user' + '/permission',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_ROLE' },
      },
      EDIT: {
        URL: '/user' + '/edit',
        permission: { moduleName: 'USER', actionName: 'ADD' },
      },
    },

    MASTER: {
      GENERAL: {
        URL: '/master' + '/general',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_FEES' },
        // permission: {} as userPermission
      },
      FEES: {
        URL: '/master' + '/fees',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_FEES' },
        // permission: {} as userPermission,
      },
      NOTICE: {
        URL: '/master' + '/notice',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_FEES' },
        // permission: {} as userPermission,
      },
      ADDNOTICE: {
        URL: '/master' + '/addnotice',
        // permission: {} as userPermission,
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_FEES' },
      },
      LOG: {
        URL: '/master' + '/message_log',
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_FEES' },
      },
    },

    FEESCOLLECTION: {
      LIST: {
        URL: '/feescollection' + '/' + ACTION.LIST,
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      RECEIPT: {
        URL: '/feescollection' + '/' + 'receipt',
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      VIEW: {
        URL: '/feescollection' + '/' + ACTION.VIEW,
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      INFO: {
        URL: '/feescollection' + '/' + ACTION.INFO,
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      ADDFEES: {
        URL: '/feescollection' + '/' + 'add_fees',
        permission: { moduleName: 'FEES', actionName: 'ADD' },
        // permission: {} as userPermission,
      },
      FEESGROUP: {
        URL: '/feescollection' + '/' + 'fees_group',
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
      },
      PAYFEES: {
        URL: '/feescollection' + '/' + 'other_fees',
        permission: { moduleName: 'FEES', actionName: 'ADD' },
        // permission: {} as userPermission,
      },
      BULK_FEES_LIST: {
        URL: '/feescollection' + '/' + 'bulkfeeslist',
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      BULK_FEES_INFO: {
        URL: '/feescollection' + '/' + 'bulkfeesinfo',
        permission: { moduleName: 'FEES', actionName: 'ADD' },
        // permission: {} as userPermission,
      },
      PENDING_LIST: {
        URL: '/feescollection' + '/' + 'pending_list',
        permission: { moduleName: 'FEES', actionName: 'VIEW_ALL' },
      },
    },

    STAFF: {
      LIST: {
        URL: '/staff' + '/' + ACTION.LIST,
        permission: { moduleName: 'STAFF', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      ADD: {
        URL: '/staff' + '/' + ACTION.ADD,
        permission: { moduleName: 'STAFF', actionName: 'ADD' },
        // permission: {} as userPermission
      },
      VIEW: {
        URL: '/staff' + '/' + ACTION.VIEW,
        permission: { moduleName: 'STAFF', actionName: 'READ' },
        // permission: {} as userPermission
      },
    },

    REPORT: {
      LIST: {
        URL: '/report' + '/' + ACTION.LIST,
        permission: { moduleName: 'REPORT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      ADD: {
        URL: '/report' + '/' + ACTION.ADD,
        permission: { moduleName: 'REPORT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      VIEW: {
        URL: '/report' + '/' + ACTION.VIEW,
        permission: { moduleName: 'REPORT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      COLLECTION: {
        URL: '/report' + '/' + 'collection',
        permission: { moduleName: 'REPORT', actionName: 'VIEW_ALL' },
      },
      DISCOUNT: {
        URL: '/report' + '/' + 'discount',
        permission: { moduleName: 'REPORT', actionName: 'VIEW_ALL' },
      }
    },

    STUDENT: {
      LIST: {
        URL: '/student' + '/' + ACTION.LIST,
        permission: { moduleName: 'STUDENT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      ADD: {
        URL: '/student' + '/' + ACTION.ADD,
        permission: { moduleName: 'STUDENT', actionName: 'ADD' },
        // permission: {} as userPermission,
      },
      VIEW: {
        URL: '/student' + '/' + ACTION.VIEW,
        permission: { moduleName: 'STUDENT', actionName: 'READ' },
        // permission: {} as userPermission,
      },
      INFO: {
        URL: '/student' + '/' + ACTION.VIEW,
        permission: { moduleName: 'STUDENT', actionName: 'READ' },
        // permission: {} as userPermission,
      },
      Details: {
        URL: '/student' + '/' + 'Details',
        permission: { moduleName: 'STUDENT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      fees_info: {
        URL: '/student' + '/' + 'fees_info',
        permission: { moduleName: 'STUDENT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      PROMOTION: {
        URL: '/student' + '/' + 'promotion',
        permission: { moduleName: 'STUDENT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
      NEWPROMOTION: {
        URL: '/student' + '/' + 'newpromotion',
        permission: { moduleName: 'STUDENT', actionName: 'ADD' },
        // permission: {} as userPermission,
      },
      PROFILE: {
        URL: '/student' + '/' + 'profile',
        permission: {} as userPermission,
      },
      PROMOTION_VIEW: {
        URL: '/student' + '/' + 'promotion_view',
        permission: { moduleName: 'STUDENT', actionName: 'READ' },
        // permission: {} as userPermission,
      },
      INFOFEES: {
        URL: '/student' + '/' + 'infofees',
        permission: { moduleName: 'STUDENT', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission,
      },
    },

    // LEAVEPOLICY: {
    //   LIST: {
    //     URL: '/leave-policy' + '/' + ACTION.LIST,
    //     permission: {} as userPermission,
    //   },
    //   ADD: {
    //     URL: '/leave-policy' + '/' + ACTION.ADD,
    //     permission: {} as userPermission,
    //   },
    // },

    SCHOOL: {
      LIST: {
        URL: '/school' + '/' + ACTION.LIST,
        permission: { moduleName: 'SCHOOL', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      ADD: {
        URL: '/school' + '/' + ACTION.ADD,
        permission: { moduleName: 'SCHOOL', actionName: 'ADD' },
        // permission: {} as userPermission
      },
      VIEW: {
        URL: '/school' + '/' + ACTION.VIEW,
        permission: { moduleName: 'SCHOOL', actionName: 'READ' },
        // permission: {} as userPermission
      },
      INFO: {
        URL: '/school' + '/' + ACTION.VIEW,
        permission: { moduleName: 'SCHOOL', actionName: 'READ' },
        // permission: {} as userPermission
      }
    },

    DEVICE_MANAGEMENT: {
      LIST: {
        URL: '/device' + '/' + ACTION.LIST,
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
        // permission: {} as userPermission
      },
      ADD: {
        URL: '/device' + '/' + ACTION.ADD,
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
        // permission: {} as userPermission
      },
      VIEW: {
        URL: '/device' + '/' + ACTION.VIEW,
        permission: { moduleName: 'MASTER', actionName: 'MANAGE_OFFICE' },
        // permission: {} as userPermission
      },
    },

    ATTENDANCE: {
      LIST: {
        URL: '/attendance' + '/' + ACTION.LIST,
        permission: { moduleName: 'ATTENDANCE', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      ADD: {
        URL: '/attendance' + '/' + ACTION.ADD,
        permission: { moduleName: 'ATTENDANCE', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },
      VIEW: {
        URL: '/attendance' + '/' + ACTION.VIEW,
        permission: { moduleName: 'ATTENDANCE', actionName: 'VIEW_ALL' },
        // permission: {} as userPermission
      },

    }

  };
}
